import GenericModel from '../generic-model';

export default class CompanySimple extends GenericModel {
  regularName?: string;
  
  constructor(id?: number, name?: string) {
    super();
    this.id = id;
    this.regularName = name;
  }
}
